﻿import { CartStorage, ICartData, ICartProductData } from "./CartStorage";

export enum QtyBehavior { Add, Set }

export class ShoppingCart {
    private cartData?: ICartData;
    private cartStorage = new CartStorage();    

    constructor() {
    }

    public get storage(): CartStorage {
        return this.cartStorage;
    }
    
    public clear(): void {
        this.cartData = undefined;
        this.cartStorage.clear();
    }
    public add(productId: number, qty: number, qtyBehavior: QtyBehavior): void {
        if (!this.cartData) {
            this.cartData = this.cartStorage.load();
            //this.cartData = {
            //    version: 2,
            //    products: []
            //};
        }
        if (!this.cartData.Prods) {
            this.cartData.Prods = [];
        }

        let entry = this.cartData.Prods?.find((el) => {
            return el.PId === productId;
        });
        if (!entry) {
            entry = {
                PId: productId,
                Qty: 0
            };
            this.cartData.Prods.push(entry);
        }
        switch (qtyBehavior) {
            case QtyBehavior.Add:
                entry.Qty += qty;
                break;
            case QtyBehavior.Set:
                entry.Qty = qty;
                break;
        }
        this.cartStorage.save(this.cartData);
    }
    public get(productId: number): ICartProductData | undefined {
        if (!this.cartData) {
            this.cartData = this.cartStorage.load();            
        }
        if (!this.cartData.Prods) {
            return undefined;
        }
        const entry = this.cartData.Prods?.find((el) => {
            return el.PId === productId;
        });
        return entry;
    }
}